import * as React from 'react';
import CrumbType from 'src/react/components/breadcrumbs/types/Crumb';
import classNames from 'classnames';
import { Link } from 'components/router/Link';
import { FC } from 'react';

type CrumbProps = CrumbType & {
  isActive: boolean,
};

const Crumb: FC<CrumbProps> = ({
  title,
  url,
  isActive,
}) => {
  if (!title) {
    return null;
  }

  const renderLink = () => {
    if (isActive || !url) {
      return title;
    }

    return (
      <Link to={url}>
        {title}
      </Link>
    );
  };

  return (
    <li
      className={classNames(
        'breadcrumb-item',
        { active: isActive },
      )}
    >
      {renderLink()}
    </li>
  );
};

export default Crumb;
